import { ApplicationRef, ComponentFactoryResolver, EmbeddedViewRef, EventEmitter, Injectable, Injector } from '@angular/core';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { ClassToggler } from '../layout/coreui/shared/toggle-classes';
import { BaseService } from '../shared/services/base.service';
import { LoaderService } from './loader.service';
import { CommonService } from './common.service';
@Injectable()
export class AsideBarService {
    public composite_action: any;
    private childComponentRef: any;
    private subject = new Subject<any>();
    private compositeFormSubject = new Subject<any>();
    private header = new Subject<string>();
    private asideBar = new Subject<any>();
    public gridData = new BehaviorSubject<any>({});
    // invokeSearch = new EventEmitter();
    public btnToggled = new Subject<any>();
    public setDataToRefresh = new Subject<any>();
    public closesidebar = new Subject<any>();
    subsVar: Subscription; hide_expand_btn : boolean = false;
    private toggler = new Subject<string>();
    private expandBtn = new Subject<string>();
    private resizeAerrow = new Subject<boolean>();
    closeBtnClicked_val = new Subject<any>();
    expandButton: boolean = false;
    public isAsideOpen: boolean = false;
    public isPreviewFormReopened: boolean = false;
    constructor(private componentFactoryResolver: ComponentFactoryResolver, private injector: Injector, private appRef: ApplicationRef, public loader: LoaderService, public baseService: BaseService, private commonService?: CommonService) { }
   
    //--------aside bar functions start which will work as modal------------
    public appendComponentTo(parentId: string = 'aside-modal-container', child: any, childConfig?: any, size: any = "lg", header: string = 'Add', selector?: any, spinner?:any): Observable<any> {
        this.isAsideOpen = true;
        this.resetResizableAside();
        this.loader.showSpinner();
        //removing component if present before
        if (this.childComponentRef != undefined && this.childComponentRef) {
            this.loader.showSpinner();
            this.removeComponent();
        }
        //setting header for the aside bar
        this.header.next(header);
        //setting toggle button in aside bar
        if(childConfig && childConfig.inputs && childConfig.inputs.toggleButton)
            this.toggler.next(childConfig.inputs.toggleButton);
        else{
            this.toggler.next(undefined);
        }
        if(childConfig && childConfig.inputs && childConfig.inputs.expand)
            this.expandBtn.next(childConfig.inputs.expand);
        else{
            this.expandBtn.next(undefined);
        }
        this.resizeAerrow.next(childConfig && childConfig.inputs && childConfig.inputs.resizeAerrow === true);
        this.hide_expand_btn = childConfig && childConfig.inputs && childConfig.inputs.hide_expand_btn ? childConfig.inputs.hide_expand_btn: false;

        this.asideBar.next(true);
        // Create a component reference from the component 
        var childComponentRef: any;
        if (selector != undefined) {
            var factories: any = this.baseService.getFactories();
            childComponentRef = this.componentFactoryResolver.resolveComponentFactory(factories[selector]).create(this.injector);
        } else {
            childComponentRef = this.componentFactoryResolver
                .resolveComponentFactory(child)
                .create(this.injector);
        }

        // Attach the config to the child (inputs and outputs)
        this.attachConfig(childConfig, childComponentRef);

        this.childComponentRef = childComponentRef;
        // Attach component to the appRef so that it's inside the ng component tree
        this.appRef.attachView(childComponentRef.hostView);

        // Get DOM element from component
        const childDomElem = (childComponentRef.hostView as EmbeddedViewRef<any>)
            .rootNodes[0] as HTMLElement;
        //check if we need to add it inside container
        //commented as we have decided to make it as a part of container always
        // if(childConfig != undefined && childConfig.container){
            childConfig.container = (typeof childConfig.container != "string")?"aside_ui_engine":childConfig.container;
            var ele = document.getElementById(parentId).getElementsByClassName(childConfig.container);
            if(ele.length){
                ele[0].appendChild(childDomElem);
            }else{
                console.error("Container not found ",childConfig.container);
            }
            // Append DOM element to the body
            
        // }else{
        //     // Append DOM element to the body
        //     document.getElementById(parentId).appendChild(childDomElem);
        // }
        
        // add dynamic size --------- Size
        var sizeModal = document.getElementById(parentId);
        var asideClass = ''
        sizeModal.classList.forEach(key => {
            if (key.indexOf('modal-aside-menu-') != -1)
                asideClass = key
        })
        sizeModal.classList.value = sizeModal.classList.value.replace(asideClass, "");
        sizeModal.classList.add("modal-aside-menu-" + size);
        //commented above and going to body level as core ui maintain asie bar via body
        this.removeAsideBar();
        document.body.classList.add("modal-aside-menu-" + size);
        //emptying as we need to get the current value only
        this.subject.observers = [];
        //show hide side bar
        this.removeClass('aside-modal-container', 'd-none');
        //hide spinner
        if(spinner == undefined)
            this.loader.hideSpinner();
        //sending data 
        return this.subject.asObservable();

    }
    getCurrentComponent() {
        return this.childComponentRef?.instance;
    }

    removeClass(id, class_) {
        if (document.getElementById(id).classList.value.includes(class_)) {
            document.getElementById(id).classList.remove(class_);
        }
    }
    
    medicationToggler(id, removeclass, addclass) {
        if (document.getElementById(id) != null) {
            document.getElementById(id).classList.remove(removeclass);
            document.getElementById(id).classList.add(addclass);
            // if(document.getElementById(id).classList.contains('show'))
            //     this.invokeSearch.emit(true);
        }
    }

    classToggler(id_) {
        if (document.getElementById(id_)) {
            document.getElementById(id_).classList.toggle('d-none');
        }
        if(document.getElementsByClassName('_op-pres-accordions') && document.getElementsByClassName('_op-pres-accordions').length > 0 && document.getElementsByClassName('_op-pres-accordions')[0].classList.contains('_aside-expanded')){
            document.getElementsByClassName('_op-pres-accordions')[0].classList.remove('_aside-expanded');
        }
    }
    asideBarClose(): Observable<any> {
        return this.asideBar.asObservable();
    }
    toggleSidebar(hide=true){
        this.asideBar.next(hide);
    }

    getToggler(): Observable<any> {
        return this.btnToggled.asObservable();
    }

    btnToggler(toggler){
        this.btnToggled.next(toggler);
    }

    getCloseSideBAr(): Observable<any> {
        return this.closesidebar.asObservable();
    }

    setCloseSideBAr(toggler){
        this.closesidebar.next(toggler);
    }

    getRefresh(): Observable<any> {
        return this.setDataToRefresh.asObservable();
    }

    setRefresh(refresh){
        this.setDataToRefresh.next(refresh);
    }

    setResizeAerrow(): Observable<boolean> {
        return this.resizeAerrow.asObservable();
    }

    expandCollapse(e){
        if(document.getElementsByClassName("cf-hc-rs-content-1") != null && document.getElementsByClassName("cf-hc-rs-content-3") != null && document.getElementsByClassName("cf-hc-rs-content-1").length > 0 && document.getElementsByClassName("cf-hc-rs-content-1")[0].classList.contains('complex-form')){
            document.querySelectorAll('.cf-hc-rs-content-1').forEach(function(el) {
                el.classList.add("nonify");
                el.classList.remove("complex-form");
            });
            document.querySelectorAll('.cf-hc-rs-content-3').forEach(function(el) {
                el.classList.add("nonify");
                el.classList.remove("complex-form");
            });
            if(document.getElementsByClassName("medication_editable") != null && document.getElementsByClassName("medication_editable").length > 0)
                document.querySelectorAll('.medication_editable').forEach(function(el) {
                    el.classList.add("nonify");
                });
        }else if(document.getElementsByClassName("cf-hc-rs-content-1") != null && document.getElementsByClassName("cf-hc-rs-content-3") != null && document.getElementsByClassName("cf-hc-rs-content-1").length > 0 && document.getElementsByClassName("cf-hc-rs-content-1")[0].classList.contains('nonify')){
            document.querySelectorAll('.cf-hc-rs-content-1').forEach(function(el) {
                el.classList.remove("nonify");
                el.classList.add("complex-form");
            });
            document.querySelectorAll('.cf-hc-rs-content-3').forEach(function(el) {
                el.classList.remove("nonify");
                // el.classList.add("complex-form");
            });
            if(document.getElementsByClassName("medication_editable") != null && document.getElementsByClassName("medication_editable").length > 0)
                document.querySelectorAll('.medication_editable').forEach(function(el) {
                    el.classList.remove("nonify");
                });
        }
    }

    private attachConfig(config, componentRef) {
        let inputs = config.inputs;
        let outputs = config.outputs;
        for(let key in inputs) {
            componentRef.instance[key] = inputs[key];
        }
        for(let key in outputs) {
            componentRef.instance[key] = outputs[key];
        }

    }
    public removeComponent(data?, decorator?) {
        if (data) {
            this.setData(data, decorator);
        }
        if (this.childComponentRef != undefined && this.childComponentRef) {
            if(data && data.currentBtnVal && data.currentBtnVal.removeAsideBar != undefined && !data.currentBtnVal.removeAsideBar && (data.action != 'MODIFY' || data.currentBtnVal.noConsider != undefined)){}else{
                this.appRef.detachView(this.childComponentRef.hostView);
                this.childComponentRef.destroy();
                if(document.getElementById('aside-modal-container') != undefined && document.getElementById('aside-modal-container'))
                    document.getElementById('aside-modal-container').classList.remove('modal-aside-menu-xl');
                if (document.getElementById('aside-modal-container') != undefined && document.getElementById('aside-modal-container') && !document.getElementById('aside-modal-container').classList.value.includes("d-none")) { this.classToggler('aside-modal-container'); }
            }
        }
        if(data && data.currentBtnVal && data.currentBtnVal.removeAsideBar != undefined && !data.currentBtnVal.removeAsideBar && (data.action != 'MODIFY' || data.currentBtnVal.noConsider != undefined)){}
        else
            this.removeAsideBar();
        if (data == undefined || (data && data.currentBtnVal == undefined && data.closeSidebar !== false || (data && data.currentBtnVal && data.currentBtnVal.closeSidebar != false)))
            this.asideBar.next(false);
        if (!(data && data.currentBtnVal && data.currentBtnVal.removeAsideBar != undefined && !data.currentBtnVal.removeAsideBar && (data.action != 'MODIFY' || data.currentBtnVal.noConsider != undefined))) {
            this.resetResizableAside();
            this.resizeAerrow.next(false);
        }
    }

    removeAsideBar() {
        var asideClass = '';
        document.body.classList.forEach(key => {
            if (key.indexOf('modal-aside-menu-') != -1)
                asideClass = key;
        })
        document.body.classList.value = document.body.classList.value.replace(asideClass, "");
    }

    private resetResizableAside() {
        document.body.classList.remove('aside-resized', 'aside-resizing');
        document.documentElement.style.removeProperty('--aside-resize-width');
        const asideContainer = document.getElementById('aside-modal-container');
        if (asideContainer) {
            asideContainer.classList.remove('aside-resizing');
        }
    }
    setData(data: any, decorator: any) {
        this.subject.next({ data: data, decorator: decorator });
        // this.clearData();
    }
    clearData() {
        this.subject.next("");
        this.header.next("");
    }
    closeBtnClicked(){
        this.closeBtnClicked_val.next(true);
    }

    processSideFormMapping(mapping, currentData) {
        let item = currentData
        if (item)
            this.nestObject(mapping, item)
        currentData = { ...currentData, ...mapping }
        return currentData
    }

    nestObject(obj, item) {
        for (let elem in obj) {
            if (typeof (obj[elem]) == 'object')
                this.nestObject(obj[elem], item)
            else {
                try{
                    if (obj == undefined || obj == 'undefined')
                        obj[elem] = '';
                    else{
                        let result = eval(obj[elem]);
                        obj[elem] = result;
                    }
                }catch(err){
                    console.log('catch error ==>', err);
                }
            }
        }
    }

    flattenObject = (obj, exceptKeys = []) => {
        const flattened = {}
        const exclude = new Set(exceptKeys) // to exclude keys that don't need to be flattened
        Object.keys(obj).forEach((key) => {
            if (typeof obj[key] === 'object' && obj[key] !== null && !exclude.has(key)) {
                if (obj[key].length != undefined && obj[key].length > 0) {
                    flattened[key] = obj[key]
                }
                else
                    Object.assign(flattened, this.flattenObject(obj[key], exceptKeys))
            } else {
                flattened[key] = obj[key]
            }
        })
        return flattened
    }

    setHeader(): Observable<any> {
        return this.header.asObservable();
    }

    setToggler(): Observable<any> {
        return this.toggler.asObservable();
    }
    setExpandBtn(): Observable<any> {
        return this.expandBtn.asObservable();
    }

    setCompositeForm(event) {
        this.compositeFormSubject.next(event);
    }
    getCompositeForm() {
        return this.compositeFormSubject.asObservable();
    }


    checkAndSaveDraft(callback: (skipAnotherPopup: boolean) => void) {
        if(!this.commonService['_manualChange']) {
            callback(false);
            return;
        }

        const component = this.getCurrentComponent();
        const resourceDef = component?._currentData?.resouceDef;
        const status = component?._currentData?.currentData?.status;
        const stage = component?._currentData?.currentData?.stage;
        const action = component?._currentData?.currentAction;
        const pageName = resourceDef?.display_name;
        const type = component?._currentData?.currentData?._type;

        const isFinal = type == "copy" ? false : (action == 'ADD' ? false : (status === 'final' || stage === 'Final'));
        if (resourceDef?.config?.showSaveAsDraftPopup && (this?.isAsideOpen || this?.isPreviewFormReopened) && !isFinal) {
            this.isPreviewFormReopened = false; // Reset the flag
            const dialogRef = this.baseService.modalService.confirm(
                `Save ${pageName}`,
                `Do you wish to save ${pageName} in draft mode?`
            );
            dialogRef.subscribe(result => {
                if (result) {
                    // User chose to save as draft
                    component?.formComponenet?.submitAsDraft((success) => {
                        callback(success);
                    });
                } else {
                    // User chose discard – can proceed with the original action
                    callback(true);
                }
            });
        } else {
            callback(false);
        }
    }
    //--------aside bar functions start which will work as modal------------
}
